import * as PropTypes from "prop-types";

export const DISCOUNT_TYPES = {
  price: "Price",
  percent: "Percent"
};

export const DISCOUNT_MODES = {
  and: "And",
  or: "Or"
};

export const discountInterFace = {
  id: PropTypes.number.isRequired,
  order: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  type: PropTypes.oneOf([DISCOUNT_TYPES.price, DISCOUNT_TYPES.percent]).isRequired,
  mode: PropTypes.oneOf([DISCOUNT_MODES.and, DISCOUNT_MODES.or]).isRequired,
  amount: PropTypes.number.isRequired,
  isRidged: PropTypes.bool.isRequired,
  isSubTotal: PropTypes.bool,
  selected: PropTypes.bool,  // it is not required, since it is not stored on the backend
  specialVisible: PropTypes.bool,  // it is not required, since it is not stored on the backend
  oldDeleted: PropTypes.bool  // it is not required, since it is not stored on the backend
};

export const discountSectionsInterface = {
  id: PropTypes.number.isRequired,
  order: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
};
